import React, { useEffect, useState } from "react";
import { ref, onValue, set } from "firebase/database";
import { database } from "./firebase";
import {
  getAuth,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";

const ADMIN_EMAIL = "jauhariali5461@gmail.com";

export default function AliAdmin() {
  const auth = getAuth();

  const [user, setUser] = useState(null);
  const [email, setEmail] = useState(ADMIN_EMAIL);
  const [password, setPassword] = useState("");

  const [isOpen, setIsOpen] = useState(true);
  const [message, setMessage] = useState("");

  /* 🔐 AUTH STATE */
  useEffect(() => {
    return onAuthStateChanged(auth, (u) => {
      setUser(u);
    });
  }, [auth]);

  /* 🔄 LOAD SITE STATUS */
  useEffect(() => {
    const r = ref(database, "siteStatus");
    onValue(r, (snap) => {
      if (snap.exists()) {
        setIsOpen(snap.val().isOpen);
        setMessage(snap.val().message || "");
      }
    });
  }, []);

  /* 🔐 LOGIN */
  const login = async () => {
    if (email !== ADMIN_EMAIL) {
      alert("Unauthorized email");
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch {
      alert("Invalid password");
    }
  };

  /* 📧 EMAIL OTP (PASSWORD RESET) */
  const resetPassword = async () => {
    if (email !== ADMIN_EMAIL) {
      alert("Unauthorized email");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset link sent to your email");
    } catch {
      alert("Failed to send reset email");
    }
  };

  /* 💾 SAVE SITE STATUS */
  const save = async () => {
    if (!user || user.email !== ADMIN_EMAIL) {
      alert("Unauthorized");
      return;
    }

    await set(ref(database, "siteStatus"), {
      isOpen,
      message: isOpen ? "" : message,
      updatedAt: Date.now(),
      updatedBy: user.email,
    });

    alert("Website status updated");
  };

  /* 🚪 LOGOUT */
  const logout = async () => {
    await signOut(auth);
  };

  /* 🔐 LOGIN PAGE */
  if (!user) {
    return (
      <div style={pageStyle}>
        <div style={cardStyle}>
          <h2>Ali Admin Login</h2>

          <input value={email} disabled style={inputStyle} />

          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
          />

          <button onClick={login} style={btnStyle}>
            Login
          </button>

          <button
            onClick={resetPassword}
            style={{ ...btnStyle, background: "#999" }}
          >
            Forgot Password
          </button>
        </div>
      </div>
    );
  }

  /* ⛔ BLOCK OTHER USERS */
  if (user.email !== ADMIN_EMAIL) {
    return <div style={pageStyle}>Access Denied</div>;
  }

  /* 👑 CONTROL PANEL */
  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <h2>Ali Control Panel</h2>

        <label>
          <input
            type="checkbox"
            checked={isOpen}
            onChange={(e) => setIsOpen(e.target.checked)}
          />{" "}
          Website ON
        </label>

        {!isOpen && (
          <textarea
            placeholder="Closing message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{ ...inputStyle, height: 80 }}
          />
        )}

        <button onClick={save} style={btnStyle}>
          Save
        </button>

        <button onClick={logout} style={{ ...btnStyle, background: "#999" }}>
          Logout
        </button>
      </div>
    </div>
  );
}

/* 🎨 STYLES */
const pageStyle = {
  height: "100vh",
  background: "#ffe6f0",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const cardStyle = {
  background: "#fff",
  padding: 30,
  borderRadius: 10,
  width: 320,
  textAlign: "center",
  border: "2px solid #ff1493",
};

const inputStyle = {
  width: "100%",
  padding: 10,
  marginBottom: 10,
};

const btnStyle = {
  width: "100%",
  padding: 10,
  background: "#ff1493",
  color: "#fff",
  border: "none",
  cursor: "pointer",
  marginBottom: 10,
};
